import "./style.scss"

import 'header'
import 'keyvisual'
import 'nav'
import 'homeservice'
import 'covid19'
import 'product'
import 'footer'

$.urlParam = function(param){
    var results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(window.location.href);
    return results[1] || 0;
}

$(document).ready(function(){
    if (window.location.href.indexOf('?a=1') > 0) {
        $('#doctornow #remark').hide();
        $('#doctornow #remarkcover').show();
    } else if (window.location.href.indexOf('?a=2') > 0) {
        $('#doctornow #remark').show();
        $('#doctornow #remarkcover').hide();
    }else {
        $('#doctornow #remark').hide();
        $('#doctornow #remarkcover').show();
    }
        if($(window).width() < 769){
            $('.toggle').click(function() {
                if($(window).width() < 769){
                    $(this).parent().nextAll('.wrap').first().toggle();
                    $(this).toggleClass('active');
                }
            });   
            $('#homeservice .text-content .detail h4').each(function(){
                if($(this).height() < 40) {
                    $(this).css({'margin-top':'20px'})
                    $(this).prev('i').css({'margin-top' : '20px'})
                }
            })
        }
})
